import { Z_INDEX_MAP } from '../constants';
export var zIndexValue = function zIndexValue(module, number) {
  if (module === void 0) {
    module = 'base';
  }

  if (number === void 0) {
    number = 0;
  }

  return (Z_INDEX_MAP[module] || 0) + number;
};